export default {
  title: {
    edit: 'Update the color',
    create: 'Create a new color',
  },
  form: {
    name: 'Label',
    colors: 'Colors',
    submit: 'Save',
  },
  delete: {
    button: 'Delete this color',
    confirm: {
      title: 'Please confirm the deletion of the "{{name}}" color',
      warning_one: 'One route use this color',
      warning_other: '{{count}} routes use this color',
      helper: 'By deleting this color, the related routes will be kept, but their color will be empty.',
      submit: 'Delete',
    },
  },
}
